import { render, staticRenderFns } from "./preview.vue?vue&type=template&id=73fb5716&scoped=true"
import script from "./preview.vue?vue&type=script&lang=js"
export * from "./preview.vue?vue&type=script&lang=js"
import style0 from "./preview.vue?vue&type=style&index=0&id=73fb5716&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73fb5716",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73fb5716')) {
      api.createRecord('73fb5716', component.options)
    } else {
      api.reload('73fb5716', component.options)
    }
    module.hot.accept("./preview.vue?vue&type=template&id=73fb5716&scoped=true", function () {
      api.rerender('73fb5716', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/hr/assess/check/components/preview.vue"
export default component.exports